import { List, Record } from 'immutable'
import { EntityAllow, IEntityAllow } from './EntityAllow'
import { ITeamMember, TeamMember } from './TeamMember'

export interface ITeam {
  readonly allowedAccessTo: List<IEntityAllow>
  readonly description: string
  readonly id: string
  readonly members: List<ITeamMember>
  readonly name: string
}

const TeamRecord = Record({
  allowedAccessTo: List<EntityAllow>(),
  description: '',
  id: '',
  members: List<TeamMember>(),
  name: '',
})

export class Team extends TeamRecord implements ITeam {
  public static fromJS(initialState?: Partial<ITeam>) {
    if (initialState) {
      const { allowedAccessTo, members, ...rest } = initialState

      return new Team({
        allowedAccessTo: allowedAccessTo
          ? List(allowedAccessTo.map((a) => EntityAllow.fromJS(a)))
          : undefined,
        members: members
          ? List(members.map((a) => TeamMember.fromJS(a)))
          : undefined,
        ...rest,
      })
    } else {
      return new Team()
    }
  }

  public readonly allowedAccessTo: List<EntityAllow>
  public readonly description: string
  public readonly id: string
  public readonly members: List<TeamMember>
  public readonly name: string

  constructor(props?: Partial<Team>) {
    props ? super(props) : super()
  }
}
